import { render } from "./DiscountRetail.vue?vue&type=template&id=2106c811&ts=true"
import script from "@/composables/master/customers/discount/discount-retail/discountRetailComposable.ts?vue&type=script&lang=ts"
export * from "@/composables/master/customers/discount/discount-retail/discountRetailComposable.ts?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Putu Mahardika\\Pictures\\vue\\hjex-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__